<template>
  <div class="record">
    <el-table 
    :data="dataList"
    v-scrollListen="{el: '.el-table__body-wrapper', fn: scrollLoad}"
    v-loading="tableLoading"
    highlight-current-row
    height="100%"
    style="width:100%">
      <el-table-column label="#" width="40" type="index" align="center"></el-table-column>
      <el-table-column label="订单创建时间" width="124">
        <template slot-scope="scope">
          <p>{{scope.row.create_time.split(' ')[0]}}</p>
          <p>{{scope.row.create_time.split(' ')[1]}}</p>
        </template>
      </el-table-column>
      <el-table-column label="订单号" width="197" prop="record_code"></el-table-column>
      <el-table-column label="购买服务/商品" width="116" prop="goods_item" align="right"></el-table-column>
      <el-table-column label="规格" width="91" align="right">
        <template slot-scope="scope">
          <p>{{scope.row.size || '—'}}</p>
        </template>
      </el-table-column>
      <el-table-column
        label="付款金额(元)"
        width="106"
        prop="pay_money"
        :formatter="formatMoney"
        align="right"
      ></el-table-column>
      <el-table-column label="支付方式" width="101" prop="pay_type" align="right" :formatter="formatPaymentWay"></el-table-column>
      <el-table-column width="5"></el-table-column>
      <el-table-column label="付款人" width="150" align="left">
        <template slot-scope="scope">
          <img
            :src="scope.row.avatar"
            class="common-head-img"
            :class="scope.row.sex === 1? 'man-border' : 'woman-border'"
          />
          <span class="common-head-text text-popper" style="width:calc(100% - 30px)" v-textPopper>{{ scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button type="text" class="clink" @click="showOrderDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <p slot="append" style="text-align:center;padding:10px;" v-if="tableLoading">{{MIXIN_TableLodingText}}</p>
      <p slot="append" style="text-align:center;padding:10px;color:#999;" v-if="!isTableDataHasMore">没有更多了</p>
    </el-table>
    <!-- 详情页展示 -->
    <orderDetail ref="orderDetail"></OrderDetail>
  </div>
</template>

<script>
import orderDetail from "./orderDetial";
export default {
  data() {
    return {
      dataList: [], // 付费记录的列表
      shopInfo: {}, // 店铺信息
    }
  },
  created() {
    this.init();
  },
  methods: {
    showOrderDetail(orderNum) {
      this.$refs.orderDetail.show(orderNum);
    },
    formatMoney(row) {
      let money = row.pay_money;
      if (money.toString().includes(".")) {
        if (money.toString().split(".")[1].length === 2) {
          return `${money}`;
        } else if (money.toString().split(".")[1].length === 1) {
          return `${money}0`;
        }
      } else {
        return `${money}.00`;
      }
    },
    /**
     * 初始化
     */
    init() {
      this.shopInfo = {
        shopID: this.$route.query.shop_id,
        shopName: this.$route.query.shop_name,
        shopType: this.$route.query.shop_type,
      }
      this.getTableList();
      this.$store.commit("SET_HEADER_INFO", {
        img: "",
        pageType: "付费中心",
        shopName: this.shopInfo.shopName,
        shopType: this.shopInfo.shopType,
      });
    },
    /**
     * 通过店铺ID和店铺类别获取付费记录的详细信息
     */
    getTableList(page = 0) {
      this.tableLoading = true
      return this.$fetch.jsonRPC({
        url: "/fee",
        method: "get_fee_list",
        params: {
          shop_id: this.shopInfo.shopID,
          shop_type: this.shopInfo.shopType,
          page: page,
          pagesize: 20
        }
      }).then(res => {
        let hasMore = res.has_more;
        let data = [];
        if(res.fee_record_list.length === 0) {
          return { data: null, has_more: false};
        }
        data = res.fee_record_list.map(currentValue => {
          const paymentDetail = currentValue.payment_detail || {};
          const claimItem = paymentDetail.claim_item || {};
          const annualFeeIncreaseInfo = currentValue.annual_fee_increase_info || {};
          return {
            record_code: currentValue.record_code,
            create_time: currentValue.create_time,
            shop_type: currentValue.shop_type,
            is_producer: currentValue.is_producer || 0,
            count: currentValue.count,
            portion_number: currentValue.portion_number,
            total_price: currentValue.total_price,
            pay_time: currentValue.pay_time,
            pay_order_number: currentValue.pay_order_number,
            pay_money: currentValue.pay_money,
            pay_type: currentValue.pay_type,
            pay_type_text: currentValue.pay_type_text || currentValue.payment_method_text || "",
            payment_method_text: currentValue.payment_method_text || currentValue.pay_type_text || "",
            payment_source_type: currentValue.payment_source_type || 0,
            payment_source_type_text: currentValue.payment_source_type_text || "",
            payer_name: currentValue.payer_name || "",
            payment_detail: paymentDetail,
            fee_code: currentValue.fee_info.fee_code,
            goods_item: claimItem.payment_target_detail || currentValue.fee_info.goods_item,
            size: claimItem.quantity_text || paymentDetail.period_text || annualFeeIncreaseInfo.version_text || currentValue.fee_info.size,
            price: currentValue.fee_info.price,
            expired_date: currentValue.fee_info.expired_date,
            nickname: currentValue.creater.nickname,
            avatar: currentValue.creater.headimgurl,
            sex: currentValue.creater.sex,
            expired_date_ls: currentValue.expired_date,
            deduction_content: currentValue.deduction_content,
            deduction_price: currentValue.deduction_price,
            discount_percent: currentValue.discount_percent,
            discount_price: currentValue.discount_price,
            expired_date_nls: currentValue.orderDetailexpired_date,
            remark: currentValue.remark,
            coupon_id: currentValue.coupon_id,
            coupon_name: currentValue.coupon_name,
            coupon_price: currentValue.coupon_price,
          }
        });
        if(page === 0){
          this.dataList = data;
          this.initScrollTable(hasMore);
        } else {
          this.dataList = this.dataList.concat(data);
        }
        return {data, has_more: hasMore}
      }).catch(e => {
        this.openMessage(0, e.error_text || "获取店铺付费列表信息失败");
      }).finally(() => {
        this.tableLoading = false
      });
    },
    formatPaymentWay(row) {
      if (row.pay_type_text) {
        return row.pay_type_text;
      }
      let paymentWay = row.pay_type;
      switch (paymentWay) {
        case 0:
          return '支付宝';
				case 1:
          return '微信';
        default:
          return '';
      }
    }
  },
  components: {
    orderDetail,
  }
};
</script>

<style lang="scss" scoped>
.record{
  height: calc(100% - 103px);
  width: 1020px;
  margin: 0 auto;

  /deep/ .el-table {
    margin: 0;
    width: 100%;
  }
  
}
</style>
